<template>
  <div class="vue-grid-wrapper">
    <div>
      <div class="layoutJSON">
        Displayed as <code>[x, y, w, h]</code>:
        <div class="columns">
          <div class="layoutItem" v-for="(item, index) in layout" :key="index">
            <b>{{ item.i }}</b
            >: {x:{{ item.x }}, y:{{ item.y }}, w:{{ item.w }}, h:{{ item.h }}}
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row no-gutters mb-2">
      <v-btn @click="addItem">Add an item dynamically</v-btn>
      <v-btn @click="reRender">ReRender</v-btn>
      <v-spacer></v-spacer>
      <v-switch
        v-model="enableEdit"
        :label="`${enableEdit ? 'Enabled' : 'Disabled'} Edit`"
      ></v-switch>
    </div>
    <!-- <template v-for="(item, index) in widgets">
      <div
        @drag="drag"
        @dragend="dragend"
        class="droppable-element"
        draggable="true"
        unselectable="on"
        :key="index"
      >
        {{ item.content }}
      </div>
    </template> -->
    <div id="content">
      <grid-layout
        v-if="render"
        ref="gridlayout"
        :layout.sync="layout"
        :col-num="colNum"
        :row-height="rowHeight"
        :is-draggable="enableEdit"
        :is-resizable="enableEdit"
        :vertical-compact="true"
        :use-css-transforms="true"
        :prevent-collision="false"
      >
        <grid-item
          v-for="(item, index) in layout"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :minH="2"
          drag-allow-from=".vue-draggable-handle"
          drag-ignore-from=".widget-body"
          :key="index"
        >
          <div class="widget-wrapper">
            <!-- <div class="vue-draggable-handle"></div> -->
            <div class="row no-gutters widget-header">
              <v-icon v-show="enableEdit" class="vue-draggable-handle"
                >mdi-drag-vertical</v-icon
              >
              <span class="my-auto" :class="{ 'pl-2': !enableEdit }">{{
                item.title
              }}</span>
              <v-spacer></v-spacer>

              <v-menu offset-y dense>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item dense>
                    <v-list-item-title>Add Widget</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteItem(index)" dense>
                    <v-list-item-title>Delete Item</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="widget-body">
              {{ item.content }}
            </div>
          </div>
          <div v-show="enableEdit" class="add-widget-wrapper">
            <v-btn
              @click="showWidgetMenu(item, $event)"
              class="add-widget-button elevation-1"
              color="pink"
              fab
              dark
              small
              bottom
              left
              ><v-icon>mdi-plus</v-icon></v-btn
            >
          </div>
        </grid-item>
      </grid-layout>
    </div>
    <v-menu
      v-model="widgetMenu.show"
      :position-x="widgetMenu.x"
      :position-y="widgetMenu.y"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item
          v-for="(item, index) in widgets"
          :key="index"
          @click="addWidget(item)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { GridLayout, GridItem } from "vue-grid-layout";
let mouseXY = { x: null, y: null };
let DragPos = { x: null, y: null, w: 1, h: 1, i: null };
export default {
  name: "Dashboard",
  route: {
    path: "/dashboard-v2",
    name: "Dashboard V2",
  },
  components: {
    GridLayout,
    GridItem,
  },
  data() {
    return {
      render: true,
      enableEdit: false,
      widgetMenu: {
        show: false,
        x: 0,
        y: 0,
      },
      newWidgetPos: {
        x: 0,
        y: 0,
      },
      layout: [
        { title: "title 0", content: "0", x: 0, y: 0, w: 2, h: 2, i: "0" },
        { title: "title 1", content: "1", x: 2, y: 0, w: 2, h: 4, i: "1" },
        { title: "title 2", content: "2", x: 4, y: 0, w: 2, h: 5, i: "2" },
        { title: "title 3", content: "3", x: 6, y: 0, w: 2, h: 3, i: "3" },
        { title: "title 4", content: "4", x: 8, y: 0, w: 2, h: 3, i: "4" },
        { title: "title 5", content: "5", x: 10, y: 0, w: 2, h: 3, i: "5" },
        { title: "title 6", content: "6", x: 0, y: 5, w: 2, h: 5, i: "6" },
        // { x: 2, y: 5, w: 2, h: 5, i: "7" },
        // { x: 4, y: 5, w: 2, h: 5, i: "8" },
        // { x: 6, y: 4, w: 2, h: 4, i: "9" },
        // { x: 8, y: 4, w: 2, h: 4, i: "10" },
        // { x: 10, y: 4, w: 2, h: 4, i: "11" },
        // { x: 0, y: 10, w: 2, h: 5, i: "12" },
        // { x: 2, y: 10, w: 2, h: 5, i: "13" },
        // { x: 4, y: 8, w: 2, h: 4, i: "14" },
        // { x: 6, y: 8, w: 2, h: 4, i: "15" },
        // { x: 8, y: 10, w: 2, h: 5, i: "16" },
        // { x: 10, y: 4, w: 2, h: 2, i: "17" },
        // { x: 0, y: 9, w: 2, h: 3, i: "18" },
        // { x: 2, y: 6, w: 2, h: 2, i: "19" },
      ],
      widgets: [
        {
          title: "Wolfgang",
          content: "Wolfgang Content",
          h: 2,
          w: 2,
        },
        {
          title: "Mozart",
          content: "Mozart Content",
          h: 2,
          w: 2,
        },
      ],
      colNum: 12,
      rowHeight: 30,
      draggable: true,
      resizable: true,
      index: 0,
      eventLog: [],
    };
  },
  watch: {
    eventLog: function() {
      const eventsDiv = this.$refs.eventsDiv;
      eventsDiv.scrollTop = eventsDiv.scrollHeight;
    },
  },
  methods: {
    // #region BASE GRID METHODS
    moveEvent: function(i, newX, newY) {
      const msg = "MOVE i=" + i + ", X=" + newX + ", Y=" + newY;
      this.eventLog.push(msg);
      console.log(msg);
    },
    movedEvent: function(i, newX, newY) {
      const msg = "MOVED i=" + i + ", X=" + newX + ", Y=" + newY;
      this.eventLog.push(msg);
      console.log(msg);
    },
    resizeEvent: function(i, newH, newW, newHPx, newWPx) {
      const msg =
        "RESIZE i=" +
        i +
        ", H=" +
        newH +
        ", W=" +
        newW +
        ", H(px)=" +
        newHPx +
        ", W(px)=" +
        newWPx;
      this.eventLog.push(msg);
      console.log(msg);
    },
    resizedEvent: function(i, newX, newY, newHPx, newWPx) {
      const msg =
        "RESIZED i=" +
        i +
        ", X=" +
        newX +
        ", Y=" +
        newY +
        ", H(px)=" +
        newHPx +
        ", W(px)=" +
        newWPx;
      this.eventLog.push(msg);
      console.log(msg);
    },
    containerResizedEvent: function(i, newH, newW, newHPx, newWPx) {
      const msg =
        "CONTAINER RESIZED i=" +
        i +
        ", H=" +
        newH +
        ", W=" +
        newW +
        ", H(px)=" +
        newHPx +
        ", W(px)=" +
        newWPx;
      this.eventLog.push(msg);
      console.log(msg);
    },
    layoutCreatedEvent: function(newLayout) {
      this.eventLog.push("Created layout");
      console.log("Created layout: ", newLayout);
    },
    layoutBeforeMountEvent: function(newLayout) {
      this.eventLog.push("beforeMount layout");
      console.log("beforeMount layout: ", newLayout);
    },
    layoutMountedEvent: function(newLayout) {
      this.eventLog.push("Mounted layout");
      console.log("Mounted layout: ", newLayout);
    },
    layoutReadyEvent: function(newLayout) {
      this.eventLog.push("Ready layout");
      console.log("Ready layout: ", newLayout);
    },
    layoutUpdatedEvent: function(newLayout) {
      this.eventLog.push("Updated layout");
      console.log("Updated layout: ", newLayout);
    },
    // #endregion BASE GRID METHODS
    /* eslint-disable */
    // drag: function(_item) {
    //   let parentRect = document
    //     .getElementById("content")
    //     .getBoundingClientRect();
    //   let mouseInGrid = false;
    //   if (
    //     mouseXY.x > parentRect.left &&
    //     mouseXY.x < parentRect.right &&
    //     mouseXY.y > parentRect.top &&
    //     mouseXY.y < parentRect.bottom
    //   ) {
    //     mouseInGrid = true;
    //   }
    //   if (
    //     mouseInGrid === true &&
    //     this.layout.findIndex((item) => item.i === "drop") === -1
    //   ) {
    //     this.layout.push({
    //       x: (this.layout.length * 2) % (this.colNum || 12),
    //       y: this.layout.length + (this.colNum || 12), // puts it at the bottom
    //       w: _item.w,
    //       h: _item.h,
    //       i: "drop",
    //     });
    //   }
    //   let index = this.layout.findIndex((item) => item.i === "drop");
    //   if (index !== -1) {
    //     try {
    //       this.$refs.gridlayout.$children[
    //         this.layout.length
    //       ].$refs.item.style.display = "none";
    //     } catch {}
    //     let el = this.$refs.gridlayout.$children[index];
    //     el.dragging = {
    //       top: mouseXY.y - parentRect.top,
    //       left: mouseXY.x - parentRect.left,
    //     };
    //     let new_pos = el.calcXY(
    //       mouseXY.y - parentRect.top,
    //       mouseXY.x - parentRect.left
    //     );
    //     if (mouseInGrid === true) {
    //       this.$refs.gridlayout.dragEvent(
    //         "dragstart",
    //         "drop",
    //         new_pos.x,
    //         new_pos.y,
    //         _item.w,
    //         _item.h
    //       );
    //       DragPos.i = String(index);
    //       DragPos.x = this.layout[index].x;
    //       DragPos.y = this.layout[index].y;
    //     }
    //     if (mouseInGrid === false) {
    //       this.$refs.gridlayout.dragEvent(
    //         "dragend",
    //         "drop",
    //         new_pos.x,
    //         new_pos.y,
    //         _item.w,
    //         _item.h
    //       );
    //       this.layout = this.layout.filter((obj) => obj.i !== "drop");
    //     }
    //   }
    // },
    // dragend: function(_item) {
    //   let parentRect = document
    //     .getElementById("content")
    //     .getBoundingClientRect();
    //   let mouseInGrid = false;
    //   if (
    //     mouseXY.x > parentRect.left &&
    //     mouseXY.x < parentRect.right &&
    //     mouseXY.y > parentRect.top &&
    //     mouseXY.y < parentRect.bottom
    //   ) {
    //     mouseInGrid = true;
    //   }
    //   if (mouseInGrid === true) {
    //     console.log(
    //       `Dropped element props:\n${JSON.stringify(
    //         DragPos,
    //         ["x", "y", "w", "h"],
    //         2
    //       )}`
    //     );
    //     this.$refs.gridlayout.dragEvent(
    //       "dragend",
    //       "drop",
    //       DragPos.x,
    //       DragPos.y,
    //       _item.w,
    //       _item.h
    //     );
    //     this.layout = this.layout.filter((obj) => obj.i !== "drop");
    //     // UNCOMMENT below if you want to add a grid-item

    //     this.layout.push({
    //       content: _item.content,
    //       x: DragPos.x,
    //       y: DragPos.y,
    //       w: _item.w,
    //       h: _item.h,
    //       i: this.index,
    //     });
    //     this.index++;

    //     this.$refs.gridlayout.dragEvent(
    //       "dragend",
    //       DragPos.i,
    //       DragPos.x,
    //       DragPos.y,
    //       _item.w,
    //       _item.h
    //     );
    //     try {
    //       this.$refs.gridlayout.$children[
    //         this.layout.length
    //       ].$refs.item.style.display = "block";
    //     } catch {}
    //   }
    // },
    drag: function(e) {
      let parentRect = document
        .getElementById("content")
        .getBoundingClientRect();
      let mouseInGrid = false;
      if (
        mouseXY.x > parentRect.left &&
        mouseXY.x < parentRect.right &&
        mouseXY.y > parentRect.top &&
        mouseXY.y < parentRect.bottom
      ) {
        mouseInGrid = true;
      }
      if (
        mouseInGrid === true &&
        this.layout.findIndex((item) => item.i === "drop") === -1
      ) {
        this.layout.push({
          x: (this.layout.length * 2) % (this.colNum || 12),
          y: this.layout.length + (this.colNum || 12), // puts it at the bottom
          w: 1,
          h: 1,
          i: "drop",
        });
      }
      let index = this.layout.findIndex((item) => item.i === "drop");
      if (index !== -1) {
        try {
          this.$refs.gridlayout.$children[
            this.layout.length
          ].$refs.item.style.display = "none";
        } catch {}
        let el = this.$refs.gridlayout.$children[index];
        el.dragging = {
          top: mouseXY.y - parentRect.top,
          left: mouseXY.x - parentRect.left,
        };
        let new_pos = el.calcXY(
          mouseXY.y - parentRect.top,
          mouseXY.x - parentRect.left
        );
        if (mouseInGrid === true) {
          this.$refs.gridlayout.dragEvent(
            "dragstart",
            "drop",
            new_pos.x,
            new_pos.y,
            1,
            1
          );
          DragPos.i = String(index);
          DragPos.x = this.layout[index].x;
          DragPos.y = this.layout[index].y;
        }
        if (mouseInGrid === false) {
          this.$refs.gridlayout.dragEvent(
            "dragend",
            "drop",
            new_pos.x,
            new_pos.y,
            1,
            1
          );
          this.layout = this.layout.filter((obj) => obj.i !== "drop");
        }
      }
    },
    dragend: function(e) {
      let parentRect = document
        .getElementById("content")
        .getBoundingClientRect();
      let mouseInGrid = false;
      if (
        mouseXY.x > parentRect.left &&
        mouseXY.x < parentRect.right &&
        mouseXY.y > parentRect.top &&
        mouseXY.y < parentRect.bottom
      ) {
        mouseInGrid = true;
      }
      if (mouseInGrid === true) {
        console.log(
          `Dropped element props:\n${JSON.stringify(
            DragPos,
            ["x", "y", "w", "h"],
            2
          )}`
        );
        this.$refs.gridlayout.dragEvent(
          "dragend",
          "drop",
          DragPos.x,
          DragPos.y,
          1,
          1
        );
        this.layout = this.layout.filter((obj) => obj.i !== "drop");
        // UNCOMMENT below if you want to add a grid-item

        this.layout.push({
          x: DragPos.x,
          y: DragPos.y,
          w: 1,
          h: 1,
          i: DragPos.i,
        });
        this.$refs.gridlayout.dragEvent(
          "dragend",
          DragPos.i,
          DragPos.x,
          DragPos.y,
          1,
          1
        );
        try {
          this.$refs.gridlayout.$children[
            this.layout.length
          ].$refs.item.style.display = "block";
        } catch {}
      }
    },
    addItem: function(item) {
      // Add a new item. It must have a unique key!
      item = item ? item : {};
      const newItem = {
        content: this.index,
        // x: (this.layout.length * 2) % (this.colNum || 12),
        // y: this.layout.length + (this.colNum || 12), // puts it at the bottom
        x: 0,
        y: 0,
        w: 2,
        h: 2,
        i: this.index,
      };
      newItem = Object.assign(newItem, item);

      this.layout.push(newItem);
      // Increment the counter to ensure key is always unique.
      this.index++;
    },
    deleteItem: function(index) {
      //console.log(index);
      //const index = this.layout.map((item) => item.i).indexOf(val);
      this.layout.splice(index, 1);
    },
    reRender() {
      this.render = false;
      this.$nextTick(() => {
        this.render = true;
      });
    },
    showWidgetMenu(item, e) {
      console.log("showWidgetMenu", e);
      e.preventDefault();

      // menu position
      this.widgetMenu.show = false;
      this.widgetMenu.x = e.clientX;
      this.widgetMenu.y = e.clientY;

      this.newWidgetPos.x = item.x;
      this.newWidgetPos.y = item.y + item.h;

      this.$nextTick(() => {
        this.widgetMenu.show = true;
      });
    },
    addWidget: function(item) {
      // Add a new item. It must have a unique key!
      item = item || {};
      let newItem = {
        content: this.index,
        // x: (this.layout.length * 2) % (this.colNum || 12),
        // y: this.layout.length + (this.colNum || 12), // puts it at the bottom
        x: this.newWidgetPos.x,
        y: this.newWidgetPos.y - 1,
        w: 2,
        h: 2,
        i: this.index,
      };
      newItem = Object.assign(newItem, item);
      this.layout.push(newItem);
      // Increment the counter to ensure key is always unique.
      this.index++;
    },
  },
  mounted() {
    console.log(this);
    this.index = this.layout.length;
    document.addEventListener(
      "dragover",
      function(e) {
        mouseXY.x = e.clientX;
        mouseXY.y = e.clientY;
      },
      false
    );
  },
};
</script>

<style lang="scss" scoped>
.vue-grid-layout {
  touch-action: none;
  background: #eee;
}
.droppable-element {
  position: relative;
  width: 150px;
  text-align: center;
  background: #fdd;
  border: 1px solid black;
  margin: 10px 0;
  padding: 10px;
  &::after {
    content: "hello";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    background: red;
    width: 90%;
  }
}

.add-widget-wrapper {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: -12px 0px;
  position: absolute;
  bottom: 0px;
  width: 100%;
  opacity: 0.1;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 1;
  }

  .add-widget-button {
    height: 20px;
    width: 20px;
    left: calc(50% - 15px);

    .v-icon {
      height: 14px;
      width: 14px;
      font-size: 14px;
    }
  }
}

.vue-grid-item {
  &:not(.vue-grid-placeholder) {
    background: #ccc;
    border: 1px solid black;
  }
  .widget-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: left;
    margin: auto;
    height: 100%;
    width: 100%;
    overflow: hidden;

    .widget-header {
      padding: 2px 0px;
    }

    .widget-body {
      padding: 1px 8px;
      height: calc(100% - 32px);
      width: 100%;
    }
  }
  .vue-draggable-handle {
    display: inline-block;
    overflow: hidden;
    line-height: 1;
    padding: 3px 0px;
    cursor: move;
    vertical-align: middle;
    font-size: 18px;
    font-family: sans-serif;
    color: #cccccc;
    text-shadow: 1px 0 1px black;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
  .minMax {
    font-size: 12px;
  }
  .add {
    cursor: pointer;
  }
  .static {
    background: #cce;
  }
  .resizing {
    opacity: 0.9;
  }
}

.layoutJSON {
  background: #ddd;
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.eventsJSON {
  background: #ddd;
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
  height: 100px;
  overflow-y: scroll;
}

// NEW
.columns {
  -moz-columns: 180px;
  -webkit-columns: 180px;
  columns: 180px;
}
</style>
<style lang="scss">
.vue-grid-item.vue-grid-placeholder {
  background: lightgray !important;
  > .vue-resizable-handle {
    background: none;
  }
}
// REMOVES SLIDE FROM LEFT ANIMATION ANTIME A WIDGET IS DELETED
.vue-grid-item {
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
  -webkit-transition-property: opacity;
  transition-property: opacity;

  &.cssTransforms {
    transition-property: opacity !important;
    right: auto;
    opacity: 1;
  }
}
</style>
